import createAction from '@/Framework/State/createAction';
import * as actionTypes from './actionTypes';
import { useDIContext } from '@/Framework/DI/DIContext';
import ScorecardRepository from '@/finsight/infrastructure/repository/ScorecardRepository';
import createAsyncRequest from '@/Framework/State/createAsyncRequest';
import { mapGetPeriodsResult } from '@/finsight/application/League/helpers';

export default (state, dispatch) => {
  const { container } = useDIContext();
  const scorecardRepository: ScorecardRepository = container.get(ScorecardRepository);

  const getLeagueTablePeriods = (payload) => {
    const method = async () => {
      const response = await scorecardRepository.getCompaniesTtmFilter(payload);

      return mapGetPeriodsResult(response);
    };
    const request = createAsyncRequest<typeof method>({
      dispatch,
      method,
      types: [
        actionTypes.GET_LEAGUE_TABLE_PERIODS,
        actionTypes.GET_LEAGUE_TABLE_PERIODS_SUCCESS,
        actionTypes.GET_LEAGUE_TABLE_PERIODS_ERROR,
      ],
    });

    return request();
  };

  const getTopRatingAgenciesPeriods = (payload) => {
    const method = async () => {
      const response = await scorecardRepository.getTopCompaniesRatingAgencyTtmFilter(payload);

      return mapGetPeriodsResult(response);
    };
    const request = createAsyncRequest<typeof method>({
      dispatch,
      method,
      types: [
        actionTypes.GET_LEAGUE_TABLE_TOP_RATING_AGENCIES_PERIODS,
        actionTypes.GET_LEAGUE_TABLE_TOP_RATING_AGENCIES_PERIODS_SUCCESS,
        actionTypes.GET_LEAGUE_TABLE_TOP_RATING_AGENCIES_PERIODS_ERROR,
      ],
    });

    return request();
  };

  const getTopUnderwritersPeriods = (payload) => {
    const method = async () => {
      const response = await scorecardRepository.getTopCompaniesUnderwriterTtmFilter(payload);

      return mapGetPeriodsResult(response);
    };
    const request = createAsyncRequest<typeof method>({
      dispatch,
      method,
      types: [
        actionTypes.GET_LEAGUE_TABLE_TOP_UNDERWRITERS_PERIODS,
        actionTypes.GET_LEAGUE_TABLE_TOP_UNDERWRITERS_PERIODS_SUCCESS,
        actionTypes.GET_LEAGUE_TABLE_TOP_UNDERWRITERS_PERIODS_ERROR,
      ],
    });

    return request();
  };

  const setTopUnderwritersPeriod = (payload) => dispatch(createAction(
    actionTypes.SET_LEAGUE_TABLE_TOP_UNDERWRITERS_PERIOD,
    payload,
  ));

  const setTopRatingAgenciesPeriod = (payload) => dispatch(createAction(
    actionTypes.SET_LEAGUE_TABLE_TOP_RATING_AGENCIES_PERIOD,
    payload,
  ));

  const setLeagueTablePeriod = (payload) => dispatch(createAction(
    actionTypes.SET_LEAGUE_TABLE_PERIOD,
    payload,
  ));

  const resetTopUnderwritersPeriod = () => dispatch(createAction(
    actionTypes.RESET_LEAGUE_TABLE_TOP_UNDERWRITERS_PERIODS,
  ));

  const resetTopRatingAgenciesPeriod = () => dispatch(createAction(
    actionTypes.RESET_LEAGUE_TABLE_TOP_RATING_AGENCIES_PERIODS,
  ));

  const resetLeagueTablePeriod = () => dispatch(createAction(
    actionTypes.RESET_LEAGUE_TABLE_PERIODS,
  ));

  return {
    getLeagueTablePeriods,
    getTopRatingAgenciesPeriods,
    getTopUnderwritersPeriods,
    setTopUnderwritersPeriod,
    setTopRatingAgenciesPeriod,
    setLeagueTablePeriod,
    resetTopUnderwritersPeriod,
    resetTopRatingAgenciesPeriod,
    resetLeagueTablePeriod,
  };
};
